module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Regular.04011b54.ttf";